// GA4 loader — runs once on first import. No-op if REACT_APP_GA_ID is not set.
const GA_ID = process.env.REACT_APP_GA_ID;

if (typeof window !== "undefined" && GA_ID && !window.__velixaGaLoaded) {
  window.__velixaGaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.gtag = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: true });
}

export const GA_ENABLED = Boolean(GA_ID);
